"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingGridRow = void 0;
const react_1 = __importDefault(require("react"));
const LoadingGridRow_styles_1 = require("./LoadingGridRow.styles");
const helpers_1 = require("../../../helpers");
const Spinner_1 = require("../../../Spinner");
const StackView_1 = require("../../../StackView");
const Text_1 = require("../../../Text");
exports.LoadingGridRow = react_1.default.memo(function LoadingGridRow({ title, style, className }) {
    return (react_1.default.createElement(LoadingGridRow_styles_1.StyledLoadingGridRow, { style: style, "data-select-id": 'grid-core-loading-row', className: (0, helpers_1.cn)('vm-LoadingGridRow', className) },
        react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.s },
            react_1.default.createElement(Spinner_1.Spinner, { size: parseInt(helpers_1.SPACING_M, 10) }),
            react_1.default.createElement(Text_1.Text, null, title || 'Loading...'))));
});
//# sourceMappingURL=LoadingGridRow.js.map